import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Checkmark14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.0644 2.99389L5.53653 11.5972L1.46967 7.53034L2.53033 6.46968L5.46346 9.40282L11.9356 2.00613L13.0644 2.99389Z'
      fill='currentColor'
    />
  </Svg>
);

Checkmark14.displayName = 'Checkmark14';
export default Checkmark14;
